import React from 'react';

/**
 * Single source for the payment-SETUP fee disclosure (#35705): on a fee-brand farm policy, a credit
 * card incurs the CC processing fee and a bank account (ACH) avoids it. Gate the render at the call
 * site with `creditCardFeeAppliesToPolicy` (core/helpers/credit-card-fee).
 *
 * A plain `<small>` with no color so it inherits the surrounding text color — this renders on both the
 * light add-payment-method modal and the dark payment-tab card. (Distinct from CreditCardFeeDisclaimer,
 * which is about an individual *payment*; this is the card-vs-ACH choice.)
 */
function CreditCardVsAchFeeNote() {
  return (
    <small>
      Credit card payments include a <strong>2.85% + $0.25</strong> processing fee. Bank account (ACH) payments have no
      fee.
    </small>
  );
}

export default CreditCardVsAchFeeNote;
